import { createSlice } from "@reduxjs/toolkit";

const initalTipsDataState = {
    data: [],
    searchField:""
}

const tipsDataSlice = createSlice({
    name: 'tipsData',
    initialState: initalTipsDataState,
    reducers:{
        setTipsData(state,action) {
            state.data = action.payload;
        },
        setSearchField(state,action){
            state.searchField=action.payload;
        }
    }
});

export const tipsDataActions = tipsDataSlice.actions;

export default tipsDataSlice.reducer;